/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import BulkNotificationsCampaignsDashboard from "../../../components/BulkNotifications/Campaigns";
import Navbar from "../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const BulkNotificationsCampaigns = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.bulkNotifications?.hasCampaignAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <BulkNotificationsCampaignsDashboard ROOT_URL={ROOT_URL} userConfig={userConfig} />
    </>
  );
};

export default BulkNotificationsCampaigns;
